module.exports = __webpack_public_path__ + "img/telephone.d43a3efd.svg";